import type { FC } from 'react';

import PageHeader from '../PageHeader.jsx';
import TableSkeleton from './TableSkeleton.jsx';

const FlowListPageSkeleton: FC = () => {
  return (
    <div className="flex h-full flex-col gap-4">
      <PageHeader />
      <TableSkeleton />
    </div>
  );
};

export default FlowListPageSkeleton;
